import React from "react";
import PropTypes from "prop-types";

export default function Form({children, onSubmit, allowSubmitOnEnter = true, ...props}) {
    return (
        <form
            onSubmit={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onSubmit();
            }}
            onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    e.stopPropagation();

                    if (!allowSubmitOnEnter) {
                        return false;
                    }

                    onSubmit();
                }
            }}
            noValidate
            {...props}
        >
            {children}
        </form>
    );
}

Form.propTypes = {
    children: PropTypes.any,
    onSubmit: PropTypes.func,
};
